(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/pay-numbergames/assets/javascripts/dialogs/want-to-subscribe-dialog.js') >= 0) return;  svs.modules.push('/components/numbergames/pay-numbergames/assets/javascripts/dialogs/want-to-subscribe-dialog.js');

'use strict';

const productMapping = svs.numbergames.productMapping;
function wantToSubscribeDialog(_ref) {
  let {
    next,
    wagers,
    syndicateId,
    product,
    wagerId
  } = _ref;
  if (productMapping.isKeno(product) || syndicateId || wagers.some(wager => wager.bets.some(bet => bet.numDraws < 5))) {
    return next();
  }
  const url = svs.core.urlMapping.get("".concat(productMapping.getBrandingClass(product), "_Prolong")).replace(':wagerId', wagerId);
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'subscription',
    allowDimmerClick: true,
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.INFO,
    title: 'Trött på att förlänga?',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: 'Börja prenumerera och du missar aldrig en dragning. Prenumerationen gäller tillsvidare och är utan bindingstid'
    }],
    actions: [{
      title: 'Nej tack',
      callback: (e, forms, dialog) => {
        svs.components.analytics.trackEvent({
          category: 'Wager',
          action: 'Q-from prolong to subscribe',
          opt_label: 'No'
        });
        dialog.close();
        next();
      }
    }, {
      title: 'Prenumerera',
      callback: () => {
        svs.components.analytics.trackEvent({
          category: 'Wager',
          action: 'Q-from prolong to subscribe',
          opt_label: 'Yes'
        }, () => {
          window.location.href = "".concat(url, "?dragningar=prenumerera");
        });
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
}
Object.assign(svs.numbergames.pay_numbergames, {
  wantToSubscribeDialog
});

 })(window);